<template>
  <div>
    <div>
      <resource-text-editor :is_flex="false" :payload="{ text_data: texts.abstract,
                                        designator: 'abstract',
                                        resource_type: 'Position',
                                        resource_id: payload.position_id,
                                        company_id: payload.company_id }">
      </resource-text-editor>
      <resource-text-editor :payload="{ text_data: texts.contact_email,
                                        designator: 'contact_email',
                                        resource_type: 'Position',
                                        resource_id: payload.position_id,
                                        company_id: payload.company_id }">
      </resource-text-editor>
      <resource-text-editor :payload="{ text_data: texts.position_company_id,
                                        designator: 'position_company_id',
                                        resource_type: 'Position',
                                        resource_id: payload.position_id,
                                        company_id: payload.company_id }">
      </resource-text-editor>
      <resource-text-editor :payload="{ text_data: texts.salary_expectations,
                                        designator: 'salary_expectations',
                                        resource_type: 'Position',
                                        resource_id: payload.position_id,
                                        company_id: payload.company_id }">
      </resource-text-editor>
      <resource-text-editor :is_flex="false" :payload="{ text_data: texts.work_entails,
                                        designator: 'work_entails',
                                        resource_type: 'Position',
                                        resource_id: payload.position_id,
                                        company_id: payload.company_id }">
      </resource-text-editor>
    </div>
  </div>
</template>
<script>
import ResourceTextEditor from '@/components/ResourceTextEditor'
export default {
  name: 'position-texts',
  props: ['payload'],
  data () {
    return {
      texts: {}
    }
  },
  created () {
    this.$network_utils.getResourceTexts({
      current_type: 'Position',
      current_resource_id: this.payload.position_id
    }).then(response => {
      this.setTexts(response)
    })
  },
  methods: {
    setTexts (texts) {
      for (let i = 0; i < texts.length; i++) {
        let text = texts[i]
        this.texts[text.designator] = text
      }
      this.$forceUpdate()
    }
  },
  components: {
    ResourceTextEditor
  }
}
</script>
